
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./css/AddRecipe.css";
import "bootstrap/dist/css/bootstrap.css";
import "./css/tableAreaReg.css"
import SideNav from "./SideNav";
import TopRootDiv from "./TopRootDiv";
import SherDineNav from "./SherDineNav";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios'
import Select, { components } from 'react-select';
import view from './images/Inventory/visible.png'
import edit from './images/MenuReg/Editing1.png'
import close from './images/Inventory/close.png'
import redClose from './images/Inventory/close (1).png'

function RecipeManagement() {

    const [collapsed, setCollapsed] = useState(false);
	const [Database, setDatabase] = useState(localStorage.getItem("DB"));
	const [imgCode, setImgCode] = useState(localStorage.getItem("imgCode"));
	const [company, setCompany] = useState(localStorage.getItem("Company"));
	const api_base_url = process.env.REACT_APP_API_BASE_URL;
	const navigate = useNavigate();

	const options = [
		{ value: '1', label: 'person' },
		{ value: '2', label: 'sadasd' },
	];

	const [selectedOption,setSelectedOption] = useState(null)

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			fontSize: '.8em',
			// fontFamily: 'Poppins',
			textAlign: 'left',
			backgroundColor: state.isSelected ? '#c8cbcf' : '#FFF',
			color: state.isFocused ? '#000' : '#000',
			cursor: 'pointer', // Add cursor pointer on hover
			':hover': {
				backgroundColor: '#c8cbcf',
				color: '#000',
			},
			':active': {
				...provided[':active'],
				backgroundColor: '#c8cbcf'
			}
		}),
		control: (provided, state) => ({
			...provided,
			width: '100%',
			// height: '2.5rem',
			minHeight: '2rem',
			fontSize: '.9em',
			borderRadius: '.1rem', // Adjust this value as needed
			padding: '0', // Ensure no extra padding is added
			// border: 'none',
			fontWeight: '500',
			// color: 'white !important', // Set text color to white
			backgroundColor: 'transparent', // Change this to 'transparent' for a clear background
			boxShadow: 'none', // Remove the blue focus shadow
			border: selectedOption ? 'none' : '1px solid #ccc', // Optional: add custom border on focus
			borderBottom: selectedOption ? '1px solid #ccc' : '1px solid #ccc',
			'&:hover': {
				borderBottom: '1px solid #c8cbcf', // Optional: border on hover
			}
			// border: state.selectValue ? '1px solid #ccc' : 'none', // Apply full border if no selected option
			// borderBottom: state.selectValue ? '2px solid #c8cbcf' : '1px solid #ccc', // Apply bottom border when option is selected
			// '&:hover': {
			// 	border: state.selectValue ? '1px solid #ccc' : 'none', // Apply full border on hover if no option selected
			// 	borderBottom: state.selectValue ? '2px solid #c8cbcf' : 'none', // Apply bottom border on hover
			// }
		}),
		valueContainer: (provided) => ({
		  ...provided,
		  height: '2.25rem',
		  minHeight: '2rem',
		  padding: '0 8px', // Center the text vertically
		  display: 'flex',
		//   color: '#fff',
		  alignItems: 'center',
		  fontSize: '.9rem'
		}),
		input: (provided) => ({
		  ...provided,
		  height: '2.25rem',
		  minHeight: '2rem',
		  margin: '0', 
		  padding: '0',
		//   color: '#fff',
		  fontSize: '.9rem' 
		}),
		indicatorsContainer: (provided) => ({
		  ...provided,
		  height: '2.25rem',
		  display: 'flex',
		  alignItems: 'center',
		  padding:'.5rem',
		  paddingTop: '0',
		  paddingBottom: '0'
		}),
		dropdownIndicator: (provided) => ({
		  ...provided,
		  padding: '0', // Remove padding to center the icon
		  width: '1rem',
		  marginLeft: '.5rem',
		//   color: '#fff',
		  cursor: 'pointer',
		}),
		placeholder: (provided) => ({
		  ...provided,
		  margin: '0',
		  fontSize: '.95em',
		//   color: '#fff',
		//   fontFamily: 'poppins'
	    }),
		menu: (provided) => ({
		  ...provided,
		  borderRadius: '.1rem', // Adjust this value as needed
		}),
		singleValue: (provided) => ({
			...provided,
			// color: 'white', // Set selected option text color to white
		}),
	};

    const [viewRecipe,setViewRecipe] = useState(false)
    const handleViewRecipe = () => {
        setViewRecipe(true)
    }

    const [rows, setRows] = useState([{ category: "", item: "", quantity: "" }]);

    const [subRecipe,setSubRecipe] = useState(false)
	const handleSubRecipe = (e) => {
		e.stopPropagation()
		setSubRecipe(a => !a)
	}

    const [isHovered, setIsHovered] = useState(false);

    const handleClose = () => {
        setViewRecipe(false)
    }

  return (
    <div className="RecipeRegMainDiv">
        <SherDineNav sideNav={setCollapsed} />
        <div className="RecipeRegContentDiv flex gap-3">
            <SideNav focus={"Inventory"} state={collapsed} />
            <div className="RecipeRegContentSideBarRight">
                <TopRootDiv
                    image={"Inventory"}
                    root={["Inventory"]}
                    section={"Recipe Management"}
                />
                <div className="Container_Menu RecipeRegForm overflow-hidden pb-0">
                    <div className="relative w-full h-full  flex flex-col gap-3">
                        <div className="h-max w-full flex text-[1rem]">
                            <div className="flex w-full gap-3">
                                <input type="text" placeholder="Search Item..."
                                className="C6C6C6 focus:outline-none bg-transparent placeholder:text-[.9rem] p-1"/>
                                <button className="bg-[#D9D9D9] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 text-[#656464] ">Search</button>
                            </div>
                            <div className="w-max">
                                <button className="text-nowrap bg-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 text-[#fff]" onClick={() => navigate('/AddRecipe')}>Add Recipe</button>
                            </div>
                        </div>
                        <div className="h-full w-full flex flex-col gap-1 font-nunito">
                            {/* head */}
                            <div className="h-max flex w-full bg-[#E5E5E5] font-[600] gap-1">
                                <div className="w-1/12 p-2">SI.</div>
                                <div className="w-3/12 p-2">Name</div>
                                <div className="w-3/12 p-2">Created By</div>
                                <div className="w-3/12 p-2">Modified</div>
                                <div className="w-2/12 p-2">Action</div>
                            </div>
                            {/* body */}
                            <div className="max-h-[65vh] flex flex-col overflow-auto gap-1">
                                <div className="h-max flex w-full gap-1">
                                    <div className="w-1/12 p-2 bg-[#fff]">1</div>
                                    <div className="w-3/12 p-2 bg-[#fff]">Pizza</div>
                                    <div className="w-3/12 p-2 bg-[#fff]">12321</div>
                                    <div className="w-3/12 p-2 bg-[#fff]">345345</div>
                                    <div className="w-2/12 p-2 bg-[#fff] flex justify-center items-center gap-3">
                                        <img className="w-[1rem] opacity-50 cursor-pointer" src={view} alt="" onClick={() => handleViewRecipe()}/>
                                        <img className="w-[1rem] opacity-75 cursor-pointer" src={edit} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            viewRecipe && (
                                <div className="absolute inset-0 bg-[#000] bg-opacity-50 p-5 flex justify-center items-center">
                                    <div className="h-full bg-[#fff] rounded-[.313rem]">
                                        <div className="flex flex-col w-full h-full">
                                            <div className="h-max sticky top-0 flex w-full bg-[#fff] pt-2 pb-2 pl-3 pr-3 rounded-t-[.313rem]">
                                                <div className="w-1/2 flex justify-start items-center">
                                                    <span>Recipe</span>
                                                </div>
                                                <div className="w-1/2 flex justify-end items-center">
                                                    <img className="w-[1rem] cursor-pointer" src={isHovered ? redClose : close} alt="" 
                                                    onMouseEnter={() => setIsHovered(true)}
                                                    onMouseLeave={() => setIsHovered(false)}
                                                    onClick={handleClose}/>
                                                </div>
                                            </div>
                                            <div className="h-full p-3 overflow-auto customScroll border-t border-t-[#aaa]">
                                                <div className="w-full h-max flex flex-col text-left borderColorCommon rounded-sm">
                                                    <div className="h-max flex p-3">
                                                        <div className="w-1/2">Pizza [large]</div>
                                                        {/* <div className="w-1/2 flex justify-end items-center"><button>Save</button></div> */}
                                                    </div>
                                                    <div className="h-full p-3 border-t border-t-[#aaa]">
                                                        <div className="borderColorCommon rounded-sm flex flex-col">
                                                            <div className="h-max p-3">
                                                                Recipe for Pizza [large]
                                                            </div>
                                                            <div className="h-full border-t border-t-[#aaa] p-3 flex flex-col gap-3">
                                                                <div className="flex flex-col gap-3">
                                                                    <div className="h-full w-full">
                                                                        <div className="w-full">
                                                                            <table className="w-full">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Item</th>
                                                                                        <th>Quantity</th>
                                                                                        <th>Unit</th>
                                                                                        <th>Area</th>
                                                                                        <th>Action</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {rows.map((row, index) => (
                                                                                        <tr key={index}>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    name="item[]"
                                                                                                    // value={row.item}
                                                                                                    className="product-input"
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    name="quantity[]"
                                                                                                    // value={row.quantity}
                                                                                                    // onChange={(e) => handleQuantityChange(index, e)}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    name="unit"
                                                                                                    // value="{unit}"
                                                                                                    // onChange={(e) => handleUnitChange(index, e)}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input 
                                                                                                    type="text" 
                                                                                                    name="Area[]"
                                                                                                    // value="{row.Area}"
                                                                                                    // onChange={(e) => handleAreaChange(index, e)}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-danger btn-sm remove-item"
                                                                                                    // onClick={() => removeRow(index)}
                                                                                                >
                                                                                                    Remove
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="borderColorCommon rounded-sm flex flex-col h-max">
                                                                    <div className="h-max p-3 pr-0 flex w-full cursor-pointer" onClick={handleSubRecipe}>
                                                                        <div className="w-1/2 flex justify-start items-center">asdasd</div>
                                                                        <div className="w-1/2 flex justify-end items-center">a<img src="" alt="" /></div>
                                                                    </div>
                                                                    {
                                                                        subRecipe && (
                                                                            <div className="p-3 flex flex-col border-t border-t-[#aaa]">
                                                                                <div className="w-full">
                                                                                    <table className="w-full">
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th>Item</th>
                                                                                                <th>Quantity</th>
                                                                                                <th>Unit</th>
                                                                                                <th>Area</th>
                                                                                                <th>Action</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {rows.map((row, index) => (
                                                                                                <tr key={index}>
                                                                                                    <td>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            name="item[]"
                                                                                                            // value={row.item}
                                                                                                            className="product-input"
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            name="quantity[]"
                                                                                                            // value={row.quantity}
                                                                                                            // onChange={(e) => handleQuantityChange(index, e)}
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            name="unit"
                                                                                                            // value="{unit}"
                                                                                                            // onChange={(e) => handleUnitChange(index, e)}
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <input 
                                                                                                            type="text" 
                                                                                                            name="Area[]"
                                                                                                            // value="{row.Area}"
                                                                                                            // onChange={(e) => handleAreaChange(index, e)}
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn btn-outline-danger btn-sm remove-item"
                                                                                                            // onClick={() => removeRow(index)}
                                                                                                        >
                                                                                                            Remove
                                                                                                        </button>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className="h-max flex justify-end items-center p-3 border-t border-t-[#aaa]"><button>Save</button></div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default RecipeManagement
